"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var Text_1 = require("./Text");
var colors_1 = require("../colors");
var base = {
    // for the Icon option
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    textAlign: 'center',
    border: 'none',
    borderRadius: '100px',
    boxShadow: 'none',
    cursor: 'pointer',
    width: '100%',
};
var variantStyles = {
    primary: {
        backgroundColor: (0, colors_1.getColor)('PURPLE_100'),
        '&:hover': {
            boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.2)',
        },
        '&:active': {
            backgroundColor: (0, colors_1.getColor)('PURPLE_CLICK'),
            boxShadow: 'none',
        },
        '&:disabled': {
            backgroundColor: (0, colors_1.getColor)('PURPLE_DISABLED'),
            boxShadow: 'none',
            cursor: 'not-allowed',
        },
    },
    secondary: {
        backgroundColor: (0, colors_1.getColor)('WHITE_100'),
        border: "1.5px solid ".concat((0, colors_1.getColor)('PURPLE_100')),
        '&:hover': {
            backgroundColor: (0, colors_1.getColor)('GRAY_BG'),
        },
        '&:active': {
            boxShadow: 'none',
        },
        '&:disabled': {
            boxShadow: 'none',
            cursor: 'not-allowed',
            backgroundColor: (0, colors_1.getColor)('GRAY_BG'),
            border: 'none',
        },
    },
    selection: {
        backgroundColor: (0, colors_1.getColor)('WHITE_100'),
        border: "1px solid ".concat((0, colors_1.getColor)('LIGHT_PURPLE_50')),
        '&:hover': {
            boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.2)',
        },
        '&:focus': {
            // .isSelected instead of :active is on purpose as this button has different behavior
            backgroundColor: (0, colors_1.getColor)('PURPLE_CLICK'),
            border: 'none',
            boxShadow: 'none',
        },
        '&:disabled': {
            boxShadow: 'none',
            cursor: 'not-allowed',
        },
    },
    buttonUnderline: {
        border: 'none',
        textDecoration: 'underline',
        color: (0, colors_1.getColor)('PURPLE_100'),
        '&:disabled': {
            color: (0, colors_1.getColor)('BLACK_100'),
            cursor: 'not-allowed',
        },
        '&:hover': {
            color: (0, colors_1.getColor)('PURPLE_100'),
        },
    },
    error: {
        backgroundColor: (0, colors_1.getColor)('RED_100'),
    },
};
var sizeStyles = {
    big: {
        height: '56px',
        padding: '16px 32px',
    },
    small: {
        height: '32px',
        padding: '8px 24px',
    },
    buttonUnderline: {
        height: '24px',
        padding: 0,
    },
};
var useStyles = (0, styles_1.makeStyles)(function () { return (__assign(__assign({ base: base }, variantStyles), sizeStyles)); });
var Button = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, iconLeft = _a.iconLeft, iconRight = _a.iconRight, isSelected = _a.isSelected, onClick = _a.onClick, size = _a.size, type = _a.type, variant = _a.variant;
    var classes = useStyles();
    var textVariant = (0, react_1.useMemo)(function () {
        switch (size) {
            case 'big':
                return 'bodyMedium';
            case 'small':
                return 'small';
            case 'buttonUnderline':
                return 'bodySemibold';
            default:
                var error = size;
                new Error("Unsupported size: ".concat(error));
                return 'bodyMedium';
        }
    }, [size]);
    var contentColor = (0, react_1.useMemo)(function () {
        switch (variant) {
            case 'primary':
                if (disabled) {
                    return 'GRAY_BG';
                }
                return 'WHITE_100';
            case 'secondary':
                if (disabled) {
                    return 'BLACK_60';
                }
                return 'PURPLE_100';
            case 'selection':
                if (disabled) {
                    return 'BLACK_20';
                }
                return isSelected ? 'WHITE_100' : 'BLACK_100';
            case 'error':
                if (disabled) {
                    return 'BLACK_100';
                }
                return isSelected ? 'WHITE_100' : 'BLACK_100';
            case 'buttonUnderline':
                return 'DARK_PURPLE_100';
            default:
                return 'WHITE_100';
        }
    }, [isSelected, disabled, variant]);
    var iconGap = (0, react_1.useMemo)(function () {
        switch (size) {
            case 'big':
                return '8px';
            case 'small':
                return '4px';
            case 'buttonUnderline':
                return 0;
            default:
                var error = size;
                new Error("Unsupported size: ".concat(error));
                return '8px';
        }
    }, [size]);
    return (react_1.default.createElement("button", { className: (0, clsx_1.default)(classes.base, classes[variant], classes[size], isSelected ? 'isSelected' : '', className), disabled: disabled || false, onClick: onClick, type: type || 'button' },
        iconLeft ? react_1.default.createElement("div", { style: { marginRight: iconGap } }, iconLeft({ color: contentColor })) : null,
        react_1.default.createElement(Text_1.Text, { color: contentColor, variant: textVariant }, children),
        iconRight ? react_1.default.createElement("div", { style: { marginLeft: iconGap } }, iconRight({ color: contentColor })) : null));
};
exports.Button = Button;
